module.exports = __webpack_public_path__ + "static/img/tool.c94e7b87.png";